var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.86612 4.86612C2.10054 4.6317 2.41848 4.5 2.75 4.5H7.34861L9.12596 7.16603C9.26506 7.37467 9.49924 7.5 9.75 7.5H19.75C20.0815 7.5 20.3995 7.6317 20.6339 7.86612C20.8683 8.10054 21 8.41848 21 8.75V19.75C21 20.0815 20.8683 20.3995 20.6339 20.6339C20.3995 20.8683 20.0815 21 19.75 21H2.75C2.41848 21 2.10054 20.8683 1.86612 20.6339C1.6317 20.3995 1.5 20.0815 1.5 19.75V5.75C1.5 5.41848 1.6317 5.10054 1.86612 4.86612ZM2.75 3C2.02065 3 1.32118 3.28973 0.805456 3.80546C0.289731 4.32118 0 5.02065 0 5.75V19.75C0 20.4793 0.289731 21.1788 0.805456 21.6945C1.32118 22.2103 2.02065 22.5 2.75 22.5H19.75C20.4793 22.5 21.1788 22.2103 21.6945 21.6945C22.2103 21.1788 22.5 20.4793 22.5 19.75V8.75C22.5 8.02065 22.2103 7.32118 21.6945 6.80546C21.1788 6.28973 20.4793 6 19.75 6H10.1514L8.37404 3.33397C8.23494 3.12533 8.00076 3 7.75 3H2.75ZM8.25 13.5C7.83579 13.5 7.5 13.8358 7.5 14.25C7.5 14.6642 7.83579 15 8.25 15H14.25C14.6642 15 15 14.6642 15 14.25C15 13.8358 14.6642 13.5 14.25 13.5H8.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderMinus);
export default __webpack_public_path__ + "static/media/folder-minus.ae9c1367cadbb8df937d34d3c98246d8.svg";
export { ForwardRef as ReactComponent };